// ** Initial State
const initialState = {
  exhibitor: [],
  // complementry: [],
  allData:[],
  data:[],
  updateInvite:null,
  bulkEmail : [],
  invitationListWithPagintion: {
    "limit": 30,
    "page": 0,
    "total_pages": null,
    "total_records": null,
    "data": null
  },
  declined_data:null,
  pageLoader:true
}

const speakerpanelist = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_EXHIBITOR':
      return { ...state, exhibitor: action.data }
    case 'GET_ALL_DATA':
      return { ...state, allData: action.data }
    case 'GET_DATA':
      return { ...state, data: action.data }
    case 'SET_DATA':
      return { ...state, data: action.data }
    // case 'COMPLEMENT_CREATION':
    //   return { ...state, complementry: action.data }
    case 'DELETE_DATA':
      return { ...state, data: action.data }
    case 'DECLINE_DATA':
      return { ...state, data: action.data }
    case 'UPDATE_INVITE':
      return { ...state, updateInvite: action.data }
    case 'SET_BULK_EMAIL':
      return { ...state, bulkEmail: action.data }
    case 'GET_ALL_INVITATION_WITH_PAGINATION':
      return { ...state, invitationListWithPagintion: action.data,pageLoader:false }
    case 'PAGE_LOADER':
      return { ...state, pageLoader: action.data }
    case 'DECLINE_FREE_INVITATION':
      return { ...state, declined_data: action.data }
    default:
      return { ...state }
  }
}
export default speakerpanelist
